import React, { Component } from 'react';
import i18n from 'i18n-react';

import apple from 'assets/images/app_store.png';
import google from 'assets/images/google_play.png';
import { BackImage, DataHandler, StorageHandler } from 'C4';
import { appURL, name, productLinks, storageKeys } from 'settings';

export default class MobileWarning extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appId: 0,
      appName: name,
    };
  }

  componentWillMount() {
    DataHandler.matchAppId().then((app) => {
      this.setState({ appId: app });
    });

    StorageHandler.load(storageKeys.appInfo)
      .then((appInfo) => {
        if (appInfo && appInfo.appName) {
          this.setState({ appName: appInfo.appName });
        }
      })
      .catch((err) => console.warn('MobileWarning: could not load app info', err));
  }

  render() {
    const { appId, appName } = this.state;
    const desktopUrl = appURL.replace(/^https?:\/\//, '');

    return (
      <div>
        <div className="container__mobileButtons">
          <BackImage darken />
          <div className="container__mobileButtons__holder">
            <h2>{i18n.translate('onMobile.header')}</h2>
            <section>{i18n.translate('onMobile.body', { appName })}</section>
            <h5>{i18n.translate('onMobile.benefits.header')}</h5>
            <ul>
              <li>{i18n.translate('onMobile.benefits.1')}</li>
              <li>{i18n.translate('onMobile.benefits.2')}</li>
              <li>{i18n.translate('onMobile.benefits.3')}</li>
            </ul>
            <section>
              {i18n.translate('onMobile.desktop', {
                link: <a href={appURL}>{desktopUrl}</a>,
              })}
            </section>
            <div className="buttons">
              <a href={productLinks.ios}>
                <img src={apple} alt="App store" />
              </a>
              <a href={productLinks.android}>
                <img src={google} alt="Google Play" />
              </a>
            </div>
            <hr />
            <span>
              {'App: '}
              {appId}
            </span>
          </div>
        </div>
      </div>
    );
  }
}
